"use client";

import Link from "next/link";
import { useCommunityCart } from "./community-cart-provider";

export function CartNavLink({ className = "" }: { className?: string }) {
  const { totalItems } = useCommunityCart();

  // hide entirely when the cart is empty — no reason to occupy header space
  if (totalItems === 0) return null;

  return (
    <Link
      href="/community/cart"
      aria-label={`Cart, ${totalItems} items`}
      className={`relative inline-flex min-h-11 min-w-11 shrink-0 items-center justify-center rounded-lg border border-line-strong bg-panel transition-colors hover:border-brand-green hover:bg-brand-green-soft active:bg-raised focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-green ${className}`}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        className="h-6 w-6"
        aria-hidden="true"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M2.25 3h1.386c.51 0 .955.343 1.087.835l.383 1.437M7.5 14.25a3 3 0 0 0-3 3h15.75m-12.75-3h11.218c1.121-2.3 2.1-4.684 2.924-7.138a60.114 60.114 0 0 0-16.536-1.84M7.5 14.25 5.106 5.272M6 20.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm12.75 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z"
        />
      </svg>
      <span aria-hidden="true" className="absolute -top-1.5 -right-1.5 flex h-5 min-w-5 items-center justify-center rounded-full bg-primary-600 px-1 text-[10px] font-semibold text-white ring-2 ring-panel">
        {totalItems > 99 ? "99+" : totalItems}
      </span>
    </Link>
  );
}
